import { RecordColorEnum } from '../../../shared/enums/record-color.enum';
import { SupplierStatusEnum } from '../enums/supplier-status.enum';

/**
 * Maps the status value to a color value which is used to style the record pill in the UI
 */
export function supplierStatusToColor(status: SupplierStatusEnum): string {
	switch (status) {
		case SupplierStatusEnum.ACTIVE:
			return RecordColorEnum.GREEN;

		case SupplierStatusEnum.ON_HOLD:
			return RecordColorEnum.RED;

		case SupplierStatusEnum.CLOSED:
			return RecordColorEnum.SLATE;

		default:
			return RecordColorEnum.DEFAULT;
	}
}
